import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'NoticeForm',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    noticeId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Notice')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetForm()
  },
  computed: {
    ...mapState({
      categoryName: state => state.notice.categoryName
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isRegister: 'noticeForm/isRegister',
      isModify: 'noticeForm/isModify'
    }),
    pageTitle () {
      return this.isRegister ?
        this.categoryName + '新規作成' :
        this.categoryName + '編集'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'noticeForm/loadModel',
      resetForm: 'noticeForm/reset'
    }),
    init () {
      this.loading = true

      //
      let serviceParams = {}
      let serviceDetailParams = {
        serviceUuid: this.userServiceUuid
      }

      // データ読出し
      this.loadModel({
        targetId: this.noticeId,
        serviceParams: serviceParams,
        serviceDetailParams: serviceDetailParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}
